import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'programmes' })
export class Programme extends HierarchyNode {}
